// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1QuRN","item":"PaymentsMobile_item__3SuS3","label":"PaymentsMobile_label__2TJas","amount":"PaymentsMobile_amount__21PLP"};